<template>
  <div class="Address">
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :validation="validation"
      :layout="layout"
      :path="path"
      :class="{ 'inline-four-columns': inlineColumns }"
      @input="handleInput"
    />
  </div>
</template>

<script>
/**
 * 
 * TODO: CBAPI - Handle changing stakeholders (GridOperator / Contractor only)
 * TODO: CBAPI - DEFERRED - cleanup unused stuff
 * 
 */
import FieldSet from '@/components/form/FieldSet.vue'

import { required, helpers } from 'vuelidate/lib/validators'
import { unicodeString } from '@/services/validation'

import { mapGetters } from 'vuex'
export default {
  name: 'StakeholderSelection',
  components: { FieldSet },
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    lock: {
      type: Boolean,
      default: false
    },
    hasRef: {
      type: Boolean,
      default: false,
    },
    inlineColumns: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // TODO: CBAPI - DEFERRED - Stakeholder slug validation rule instead of unicodeString
      validation: {
        'Municipality': {
          required,
        },
        'ChargePointOperator': {
          required,
          unicodeString: (value) => !helpers.req(value) || unicodeString(value.replace('|', '')),
        },
        'GridOperator': {
          required,
          unicodeString: (value) => !helpers.req(value) || unicodeString(value.replace('|', '')),
        },
        'Contractor': {
          unicodeString: (value) => !helpers.req(value) || unicodeString(value.replace('|', '')),
        },
      },
    }
  },
  computed: {
    ...mapGetters('tenant', [
      'isCurrentTenant',
      'getExistingContractors',
    ]),
    ...mapGetters('stakeholders', [
      'getMunicipalities',
      'getContractors', 
      'getGridOperators',
      'getChargePointOperators'
    ]),
    /**
     * Disable if set and stored (record has a DB ref)
     */
    disableMunicipality() {
      return this.values.Municipality !== null && this.hasRef
    },
    
    contractors () {
      return this.getExistingContractors
        .slice()
        .sort((a, b) => {
          return (a.enabled === b.enabled)
            ? (a.label || '').localeCompare((b.label || ''))
            : (a.enabled === false ? 1 : -1)
        })
        .map(contractor => (
          {
            value: contractor.uuid,
            text: contractor.label,
            disabled: !contractor.enabled,
          }
        ))
    },
    layout() {
      return [
        {
          'columns': '1fr',
          'fields': ['Municipality'],
        },
        {
          'columns': '1fr',
          'fields': ['ChargePointOperator'],
        },
        {
          'columns': '1fr',
          'fields': ['GridOperator'],
        },
        {
          'columns': '1fr',
          'fields': ['Contractor'],
        },
      ]
    },
    fields() {
      let fields = {
        'Municipality': {
          'type': 'string',
          'title': 'Behandelende gemeente',
          'disabled': this.disableMunicipality,
          'options': this.getMunicipalities.map(stakeholder => {
            return {
              value: stakeholder.slug,
              text: stakeholder.name,
              disabled: stakeholder.enabled === false,
            }
          }),
        },
        'GridOperator': {
          'type': 'string',
          'title': 'Netbeheerder',
          format: 'select',
          options: this.getGridOperators.map(stakeholder => {
            return {
              value: stakeholder.slug,
              text: stakeholder.name,
              disabled: stakeholder.enabled === false,
            }
          }),
          'disabled': this.disabled,
        },
        'ChargePointOperator': {
          type: 'string',
          title: 'CPO',
          format: 'select',
          options: this.getChargePointOperators.map(stakeholder => {
            return {
              value: stakeholder.slug,
              text: stakeholder.name,
              disabled: stakeholder.enabled === false,
            }
          }),
          disabled: this.disabled || this.getChargePointOperators.length < 2
        },  
        'Contractor': {
          'type': 'string',
          'title': 'Aannemer',
          'options': this.getContractors.map(stakeholder => {
            return {
              value: stakeholder.slug,
              text: stakeholder.name,
              disabled: stakeholder.enabled === false,
            }
          }),
          'disabled': this.disabled,
          format: 'select',
        },
      }

      return fields
    },
  },
  created() {
    // this.setDefaults()
  },
  methods: {
    setDefaults() {

      console.log("SET DEFAULTS", this.getChargePointOperators.length, this.getChargePointOperators[0].slug)

      /**
       * CHARGE POINT OPERATOR
       */
      // TODO: CBAPI: Migration... 
      if (
        this.values.ChargePointOperator && ! this.values.ChargePointOperator.includes('|')
      ) {
        console.log("CPO migrate...")
        let stakeholder = this.getChargePointOperators.find(stakeholder => 
          stakeholder.name === this.values.ChargePointOperator
        )
        if (stakeholder) {
          // this.values.ChargePointOperator = slug
          this.$emit('input', { 
            name: 'ChargePointOperator', 
            value: stakeholder.slug
          })
        }
      }
      // Otherwise check whether we can set a default
      else if (
        ! this.values.ChargePointOperator &&
        this.getChargePointOperators.length === 1
      ) {
        
        console.log("CPO DEFAULT")

        // this.values.ChargePointOperator = this.getChargePointOperators[0].slug
        this.$emit('input', { 
          name: 'ChargePointOperator', 
          value: this.getChargePointOperators[0].slug
        })
      }

      /**
       * Municipality
       */
      if (
        ! this.values.Municipality &&
        this.getMunicipalities.length === 1
      ) {
        // this.values.Municipality = this.getMunicipalities[0].slug

        // The last part of the municipality slug is the geography code (e.g. municipality|tiel-0281)
        this.$emit('input', { 
          name: 'Municipality', 
          value: this.getMunicipalities[0].slug
        })
        this.$emit(
          'setMunicipality', 
          this.getMunicipalities[0].slug.split('-').reverse()[0]
        )
      }

      /**
       * Grid Operator
       */
      if (
        ! this.values.GridOperator &&
        this.getGridOperators.length === 1
      ) {
        // this.values.GridOperator = this.getGridOperators[0].slug
        this.$emit('input', { 
          name: 'GridOperator', 
          value: this.getGridOperators[0].slug
        })
      }

      /**
       * Contractors
       */
      if (
        ! this.values.Contractor &&
        this.getContractors.length === 1
      ) {
        // this.values.Contractor = this.getContractors[0].slug
        this.$emit('input', { 
          name: 'Contractor', 
          value: this.getContractors[0].slug
        })
      }
    },
    handleInput({ name, value }) {
      if (name === 'Contractor' || name === 'GridOperator'){
        this.$emit('setStakeholders', { name, value, label: this.fields?.[name]?.title || 'belanghebbende' })
      }
      
      console.log("handleInput", name, value, this.values.Municipality)

      if ([`${ this.path ? this.path+'.' : '' }Municipality`].includes(name) && value) {
        if (this.values.Municipality !== value) {
          console.log("EMIT EVENT - setMunicipality")
          this.$emit('setMunicipality', value.split('-').reverse()[0])
        }
      } else {
        this.$emit('input', { name, value, label: this.fields?.[name]?.title || 'belanghebbende' })
      }
    }
  },
}
</script>
